import Vue from 'vue'
import Vuex, { StoreOptions, ActionContext } from 'vuex';

const module = {
  namespaced: true, // 지정을 해줘야 RootState와 따로 동작한다. 없으면, RootState 변경시 같이 변경
  state: {
    data: '',  //RootState와 똑같이 작성해도 된다.
    location:  [],
    baseLocation: 'N2CDT002580',
    idcList: null,  //로그인 후 출입 권한이 있는 IDC 목록을 가지고 있음.
    currentIdc: null,
  },
  mutations: {
    addLocation(state, data){
      state.location = JSON.parse(sessionStorage.getItem('location')) || [];

      if(JSON.stringify(data) != JSON.stringify(state.location)){
        state.location = Object.assign([], data)
        sessionStorage.setItem('location', JSON.stringify(state.location));
      }
    },
    deleteAllLocation(state, data){
      sessionStorage.removeItem('location');
    },
    setIdcList(state, data){
      state.idcList = data;
    },
    setCurrentIdc(state, data){
      sessionStorage.setItem('currentIdc', JSON.stringify(data));
      state.currentIdc = data;
    }
  },
  actions: {
    addLocation({commit}, data) {
      commit('addLocation', data);
    },
    deleteAllLocation({commit}, data){
      commit('deleteAllLocation', data);
    },
    setIdcList({commit}, empNumber) {

      if(empNumber == null) return [];

      return Vue.prototype.$http.get('/api/public/location/idcList?empNo='+empNumber)
        .then((result) => {
          commit('setIdcList', result.data);
          return result.data;
        }).catch((e) => {
          console.log(e);
          return [];
        })
    },
    setCurrentIdc({commit}, data){
      commit('setCurrentIdc', data);
    }
  },
  getters: {
    location: async function(state){
      if(!sessionStorage.getItem('location')){
        return await Vue.prototype.$http.get('/api/private/location/'+ state.baseLocation)
          .then((result) => {
            store.dispatch('location/addLocation', result.data.children);
            return result.data.children;
          }).catch((e) =>{
            console.log(e)
          })
      }else{
        state.location = JSON.parse(sessionStorage.getItem('location') || null);
        return  state.location;
      }
    },
    currentIdc: function(state){
      state.currentIdc = JSON.parse(sessionStorage.getItem('currentIdc') || null);
      return state.currentIdc;
    }
  }
}
export default module;
